import { __decorate } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { TextField } from '../text-field/TextField';
import autobind from '../_util/autobind';
import Icon from '../icon';
// let selectionStart;
// let selectionEnd;
let Password = class Password extends TextField {
    constructor() {
        super(...arguments);
        this.type = 'password';
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'reveal',
        ]);
    }
    getOtherPrevNode() {
        return React.createElement("input", { tabIndex: -1, className: `${this.prefixCls}-fix-autofill` });
    }
    getInnerSpanButton() {
        const { reveal } = this.props;
        if (reveal && !this.disabled) {
            return this.wrapperInnerSpanButton(React.createElement(Icon, { type: this.reveal ? 'visibility' : 'visibility_off', onClick: this.handleToggleReveal }), {
                style: { right: this.lengthInfoWidth },
            });
        }
    }
    handleToggleReveal(e) {
        e.preventDefault();
        if (!this.isFocused) {
            this.focus();
        }
        const target = this.element;
        if (target) {
            if (target.type === 'password') {
                this.doReveal(target);
            }
            else {
                this.resetReveal(target);
            }
        }
    }
    doReveal(target) {
        this.selectionEnd = target.selectionEnd;
        this.selectionStart = target.selectionStart;
        target.type = 'text';
        this.type = target.type;
        this.reveal = true;
    }
    resetReveal(target) {
        const { selectionStart, selectionEnd } = this;
        target.type = 'password';
        this.type = target.type;
        if (typeof selectionStart !== 'undefined' && typeof selectionEnd !== 'undefined') {
            target.setSelectionRange(selectionStart, selectionEnd);
            this.selectionStart = undefined;
            this.selectionEnd = undefined;
        }
        this.reveal = false;
    }
};
Password.displayName = 'Password';
Password.propTypes = {
    /**
     * 是否可揭示
     * @default true
     */
    reveal: PropTypes.bool,
    ...TextField.propTypes,
};
Password.defaultProps = {
    ...TextField.defaultProps,
    suffixCls: 'password',
    reveal: true,
};
__decorate([
    observable
], Password.prototype, "reveal", void 0);
__decorate([
    autobind
], Password.prototype, "handleToggleReveal", null);
__decorate([
    action
], Password.prototype, "doReveal", null);
__decorate([
    action
], Password.prototype, "resetReveal", null);
Password = __decorate([
    observer
], Password);
export default Password;
